import { Component, forwardRef } from '@angular/core';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { User} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { AuthenticationType } from 'src/app/services/oidc.factory';

import { CognitoService } from 'src/app/services/cognito.service';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-profile-mfa',
  templateUrl: './profile-mfa.component.html',
  styleUrls: ['./profile-mfa.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => ProfileMfaComponent)}]
})
export class ProfileMfaComponent extends WizardScreenComponent {
  public loggedInDirectly: boolean;

  private preferredMfaSetting: string;
  public mfaSecret: string;
  public mfaQrUri: string;
  mfaEnabled: boolean;
  totpVerified = false;
  dirty = false;

  constructor(private _sessionService: SessionService, private _apiService: PlatformApiService, private _cognitoService: CognitoService, public dialog: MatDialog) {
    super();
    this.loggedInDirectly = _sessionService.getAuthenticationType() == AuthenticationType.COGNITO;

    this.form = new FormGroup ({
      totpCode: new FormControl(''),
    });
  }

  onLoad() {
    if (this.loggedInDirectly) {
      this.form.reset();
      this.dirty = false;
      this.mfaSecret = undefined;
      this.mfaQrUri = undefined;
      this.showSpinner()
      this._cognitoService.getMfaStatus().then(preferredMfaSetting => {
        this.preferredMfaSetting = preferredMfaSetting;
        this.mfaEnabled = (this.preferredMfaSetting == 'SOFTWARE_TOKEN_MFA')
        this.hideSpinner()
        super.onLoad();
      });
    }
  }

  getMfaSecret() {
    this._cognitoService.getMfaSecretCode().then(secret => {
      this.dirty = true;
      const encoded = `${encodeURIComponent('ConnectWise Identify')}:${encodeURIComponent(this._sessionService.getCurrentUser().email)}?secret=${secret}&issuer=${encodeURIComponent('ConnectWise Identify')}`;
      this.mfaSecret = secret;
      this.mfaQrUri = `otpauth://totp/${encoded}`;
    })
  }

  verifyTotpToken() {
    this._cognitoService.verifyTotpCode(this.form.controls.totpCode.value).then(res => {
      this.totpVerified = true;
      this.enableMfa();
    }).catch(err => {
      this.form.controls.totpCode.setErrors({invalidTotp: true});
    });
  }

  enableMfa() {
    this.showSpinner('Enabling MFA for your login');
    this._cognitoService.enableMfa().then(() => {
      this.dirty = false;
      this.totpVerified = false;
      this.mfaSecret = undefined;
      this.mfaQrUri = undefined;
      this.mfaEnabled = true;
      this.showMessage('MFA has been enabled. You will need to provide the code from your authenticator app when you log in.');
    });
  }

  disableMfa() {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [`Disabling MFA will invalidate your current two-factor authenticator device.`, `You will need to setup a new authenticator device to re-enable it.`, `Do you want to disable MFA?`],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this._cognitoService.disableMfa().then(() => {
          this.mfaEnabled = false;
        });
      }
    });
  }

  isDirty():boolean {
    return this.dirty;
  }
}